import styled from 'styled-components';

import React from 'react';

const Div = styled.div`
    color: ${(props) => props.theme.tertiaryFontColor};
    font-family: Poppins;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    
    /* Responsive sizing to make room for buttons */
    @media (max-width: 640px) {
        font-size: 24px;
    }
`;

const Heading = ({ className, children }) => {
    return <Div className={className}>{children}</Div>;
};

export default Heading;
